<template>
  <div>
    <p class="view_head">获奖信息</p>
    <div style="display: flex;flex-flow: column;">
      <div class="qc_clumView">
        <div class="inner_title">
          <p>获省部级及以上工程质量奖(近三年)</p>
          <div class="input-box">
            <label class="input-box__label">{{ formData[0].number }}</label>
            <input
              type="text"
              class="input-box__input"
              v-model="formData[0].number"
            />
          </div>
          <p>项:</p>
        </div>
        <div class="qc_clumView_right">
          <!-- @blur="labelInput(newform.activity,'activity')" -->
          <el-input
            type="textarea"
            :rows="4"
            :placeholder="formTip.tip1"
            v-model="formData[0].award_name"
          >
          </el-input>
        </div>
      </div>
      <div class="qc_clumView">
        <div class="inner_title">
          <p>获省部级及以上科学技术奖(近三年)</p>
          <div class="input-box">
            <label class="input-box__label">{{ formData[1].number }}</label>
            <input
              type="text"
              class="input-box__input"
              v-model="formData[1].number"
            />
          </div>
          <p>项:</p>
        </div>

        <div class="qc_clumView_right">
          <el-input
            type="textarea"
            :rows="2"
            :placeholder="formTip.tip2"
            v-model="formData[1].award_name"
          >
          </el-input>
        </div>
      </div>
      <div class="qc_clumView">
        <div class="inner_title">
          <p>
            近3年获得工程建设行业科学技术奖、工程建设科技推广奖、工程建设科学技术创新奖、技术发明奖、科技进步奖
          </p>
          <div class="input-box">
            <label class="input-box__label">{{ formData[2].number }}</label>
            <input
              type="text"
              class="input-box__input"
              v-model="formData[2].number"
            />
          </div>
          <p>项:</p>
        </div>

        <div class="qc_clumView_right">
          <el-input
            type="textarea"
            :rows="2"
            :placeholder="formTip.tip3"
            v-model="formData[2].award_name"
          >
          </el-input>
        </div>
      </div>
      <div class="qc_clumView">
        <div class="inner_title">
          <p>
            近3年省部级及以上科技成果（科研成果、标准、发明专利、工法等）产生的经济效益和社会效益
          </p>
          <div class="input-box">
            <label class="input-box__label">{{ formData[3].number }}</label>
            <input
              type="text"
              class="input-box__input"
              v-model="formData[3].number"
            />
          </div>
          <p>项:</p>
        </div>

        <div class="qc_clumView_right">
          <el-input
            type="textarea"
            :rows="6"
            :placeholder="formTip.tip4"
            v-model="formData[3].award_name"
          >
          </el-input>
        </div>
      </div>
      <div class="qc_clumView">
        <div class="inner_title">
          <p>在核心期刊上发表论文</p>
          <div class="input-box">
            <label class="input-box__label">{{ formData[4].number }}</label>
            <input
              type="text"
              class="input-box__input"
              v-model="formData[4].number"
            />
          </div>
          <p>项:</p>
        </div>

        <div class="qc_clumView_right">
          <el-input
            type="textarea"
            :rows="2"
            :placeholder="formTip.tip5"
            v-model="formData[4].award_name"
          >
          </el-input>
        </div>
      </div>
      <div class="qc_clumView">
        <div class="inner_title">
          <p>
            近3年获得的省部级及以上智慧工地示范项目、创新应用大赛成果、BIM相关奖项
          </p>
          <div class="input-box">
            <label class="input-box__label">{{ formData[5].number }}</label>
            <input
              type="text"
              class="input-box__input"
              v-model="formData[5].number"
            />
          </div>
          <p>项:</p>
        </div>

        <div class="qc_clumView_right">
          <el-input
            type="textarea"
            :rows="4"
            :placeholder="formTip.tip6"
            v-model="formData[5].award_name"
          >
          </el-input>
        </div>
      </div>
      <div class="qc_clumView">
        <div class="inner_title">
          <p>公开出版的专著</p>
          <div class="input-box">
            <label class="input-box__label">{{ formData[6].number }}</label>
            <input
              type="text"
              class="input-box__input"
              v-model="formData[6].number"
            />
          </div>
          <p>项:</p>
        </div>
        <div class="qc_clumView_right">
          <el-input
            type="textarea"
            :rows="4"
            :placeholder="formTip.tip7"
            v-model="formData[6].award_name"
          >
          </el-input>
        </div>
      </div>
      <div class="qc_clumView">
        <div class="inner_title">
          <p>个人荣誉</p>
          <div class="input-box">
            <label class="input-box__label">{{ formData[7].number }}</label>
            <input
              type="text"
              class="input-box__input"
              v-model="formData[7].number"
            />
          </div>
          <p>项:</p>
        </div>

        <div class="qc_clumView_right">
          <el-input
            type="textarea"
            :rows="6"
            :placeholder="formTip.tip8"
            v-model="formData[7].award_name"
          >
          </el-input>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      happyTest: "",
      newform: {},
      formTip: {
        tip1: `1、××××年××月至××××年××月承建/参建×××项目：造价××元，开、竣工时间。本人担任该项目的项目经理。该工程获××年度××省（/全国）××奖（获奖文件见第××页）。
2.×××项目：……同上。
…………`,
        tip2: `1.“×××技术”获×××科学技术×等奖，本人排名第×（获奖证书见第××页）。
2.…………同上。          （注：奖项由高等级到低等级依次填写）`,
        tip3: `1. “ × × ×项目或成果名称 ”获×× ×科学技术奖××等奖，获奖时间× × ×。
2. ……同上。           （注：奖项按高等级到低等级序号填写）`,
        tip4: `1.科研成果：“ × × ×项目或成果名称 ”，本人排名第× ，获得时间× × ×， 取得××经济效益/社会效益。
2.标准名称： × × × , 编号： × × × , 标准发布单位： × × × , 主编或参编，标准发布时间： ×年×月× 日，取得××经济效益/社会效益。
3.授权专利名称×× × ,本人排名第× , 授权时间： ×年×月× 日，取得××经济效益/社会效益
4. 工法名称： × × × , 工法发布单位： × × × , 工法编制单位： × × × , 工法评定时间×年×月× 日，取得××经济效益/社会效益。`,
        tip5: `1.《×××》（《××杂志》，×年第×期），第×作者。
…………（注：先写排名第一，再写其他排名）`,
        tip6: `1.“ × × ×项目或成果名称 ”获×× 科学技术奖××等奖，获奖时间× ×。
2.……同上。`,
        tip7: `1.主编：《××××》，第×作者
…………
2.参编：《××××》，第×作者
…………`,
        tip8: `1.被评为“××××称号”；（证书见第××页）
2.获国家（省部级）“××××奖”；
3.被评为××××年度“××××”；
4.被评为××××年“××××优秀项目经理/先进工作者/标兵”；
.......
（注：主要填写土木工程领域的个人荣誉，最多填写6项。）`,
      },
      formData: [
        {
          project_name: "获省部级及以上工程质量奖(近三年)",
          award_name: "",
          award_time: "",
          project_app_num: "",
          pa_award_type: "",
          number: "",
        },
        {
          project_name: "获省部级及以上科学技术奖(近三年)",
          award_name: "",
          award_time: "",
          project_app_num: "",
          pa_award_type: "",
          number: "",
        },
        {
          project_name:
            "近3年获得工程建设行业科学技术奖、工程建设科技推广奖、工程建设科学技术创新奖、技术发明奖、科技进步奖",
          award_name: "",
          award_time: "",
          project_app_num: "",
          pa_award_type: "",
          number: "",
        },
        {
          project_name:
            "近3年省部级及以上科技成果（科研成果、标准、发明专利、工法等）产生的经济效益和社会效益",
          award_name: "",
          award_time: "",
          project_app_num: "",
          pa_award_type: "",
          number: "",
        },
        {
          project_name: "在核心期刊上发表论文",
          award_name: "",
          award_time: "",
          project_app_num: "",
          pa_award_type: "",
          number: "",
        },
        {
          project_name:
            "近3年获得的省部级及以上智慧工地示范项目、创新应用大赛成果、BIM相关奖项",
          award_name: "",
          award_time: "",
          project_app_num: "",
          pa_award_type: "",
          number: "",
        },
        {
          project_name: "公开出版的专著",
          award_name: "",
          award_time: "",
          project_app_num: "",
          pa_award_type: "",
          number: "",
        },
        {
          project_name: "个人荣誉",
          award_name: "",
          award_time: "",
          project_app_num: "",
          pa_award_type: "",
          number: "",
        },
      ],
    };
  },
  props: {
    datas: {
      type: Array,
      default: () => [],
    },
  },
  watch: {
    datas(newValue) {
      if (newValue) {
        this.formData = [...newValue];
      }
    },
  },
  methods: {
    getData() {
      return this.formData;
    },
  },
};
</script>

<style scoped>
.view_head {
  font-size: 18px;
  font-weight: bold;
  margin-top: 20px;
}

.qc_list {
  display: flex;
  align-items: center;
  margin: 10px;
}

.qc_clumView {
  width: 100%;
  display: flex;
  flex-flow: column;
  margin: 10px;
  padding-left: 50px;
  /* padding-left: 170px; */
}

.qc_newAdd {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 92%;
  margin-bottom: 10px;
}

.qc_clumView p {
  text-align: left;
  font-size: 14px;
  display: inline-block;
  margin-bottom: 10px;
}

.qc_clumView_right {
  width: calc(100% - 70px);
}

.qc_list__Right {
  padding-left: 20px;
}

.qc_list p {
  font-size: 14px;
  width: 150px;
  text-align: right;
  display: inline-block;
}

.input-box {
  display: inline-flex;
  align-items: center;
  box-sizing: border-box;
  position: relative;
  border-bottom: 1px solid #000;
  height: 20px;
  line-height: 20px;
  min-width: 50px;
  /* font family is very important */
  font-family: Arial, "microsoft yahei";
  font-size: 14px;
}

.input-box__label {
  display: inline-block;
  font-size: inherit;
  line-height: normal;
  visibility: hidden;
  font-family: inherit;
  padding: 0 10px;
}

.input-box__input {
  box-sizing: border-box;
  position: absolute;
  display: inline;
  font-size: inherit;
  font-family: inherit;
  line-height: normal;
  border-radius: inherit;
  height: 100%;
  width: 100%;
  outline: 0;
  border: 0;
  margin: 0;
  padding: 0 10px;
}

.inner_title {
  text-align: left;
}
</style>
